import axios from 'axios';
import intimacaoWebApiTokenInterceptor from './intimacaoWebApi/intimacaoWebApiTokenInterceptor';
import { success, error } from './intimacaoWebApi/intimacaoWebApiTokenValidateInterceptor';

const instance = axios.create();
const baseURL = process.env.VUE_APP_intimacaoWebApiUrl
//const headers = { 'X-Requested-With': 'XMLHttpRequest' };
//const headers = { 'X-Requested-With': 'XMLHttpRequest', 'X-XSS-Protection': '1; mode=block', 'X-Content-Type-Options': 'nosniff', 'Content-Security-Policy': 'script-src' };
//DEV
//const headers = { 'X-Requested-With': 'XMLHttpRequest', 'X-XSS-Protection': '1; mode=block', 'X-Content-Type-Options': 'nosniff', 'Content-Security-Policy': "script-src 'self' scripts.apidev.kurierservicos.com.br/kintimacaoportaldev; media-src 'self'; img src *; default-src 'self' https://*.apidev.kurierservicos.com.br/kintimacaoportaldev" };
//PROD
const headers = { 'X-Requested-With': 'XMLHttpRequest', 'X-XSS-Protection': '1; mode=block', 'X-Content-Type-Options': 'nosniff', 'Content-Security-Policy': "script-src 'self' scripts.intimacao.kurierservicos.com.br; media-src 'self'; img src *; default-src 'self' https://*.intimacao.kurierservicos.com.br" };

instance.interceptors.request.use(intimacaoWebApiTokenInterceptor)
instance.interceptors.response.use(success, error)
instance.defaults.timeout = 600000

import PerfilPortalAPI from './intimacaoWebApi/PerfilPortalAPI';
import UsuarioWebAPI from './intimacaoWebApi/UsuarioWebAPI';
import StoreWebAPI from './intimacaoWebApi/StoreWebAPI';
import ClienteAPI from './intimacaoWebApi/ClienteAPI';
import PerfilTribunalAPI from './intimacaoWebApi/PerfilTribunalAPI';
import ContratoAPI from './intimacaoWebApi/ContratoAPI';
import FontesPOLAPI from './intimacaoWebApi/FontesPOLAPI';
import TermoAPI from './intimacaoWebApi/TermoAPI';
import IntimacoesAPI from './intimacaoWebApi/IntimacoesAPI';

export default {
    ...PerfilPortalAPI({instance, baseURL, headers}),
    ...UsuarioWebAPI({instance, baseURL, headers}),
    ...StoreWebAPI({instance, baseURL, headers}),
    ...ClienteAPI({instance, baseURL, headers}),
    ...PerfilTribunalAPI({instance, baseURL, headers}),
    ...ContratoAPI({instance, baseURL, headers}),
    ...FontesPOLAPI({instance, baseURL, headers}),
    ...TermoAPI({instance, baseURL, headers}),
    ...IntimacoesAPI({instance, baseURL, headers}),
};